/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { OnboardingDatapoint } from "./OnboardingDatapoint";
export const OnboardingDatapointResponse = core.serialization.object({
    data: OnboardingDatapoint,
});
